import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=9f8bd7fa&scoped=true&"
import script from "./TicketsView.vue?vue&type=script&lang=js&"
export * from "./TicketsView.vue?vue&type=script&lang=js&"
import style0 from "./TicketsView.vue?vue&type=style&index=0&id=9f8bd7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8bd7fa",
  null
  
)

export default component.exports